<script>
export default {
  name: 'BasePageTitle',
}
</script>

<template>
  <h1 class="page-title">
    <slot />
  </h1>
</template>

<style lang="scss" scoped>
@import '@/styles/_colors.scss';

.page-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  line-height: 1;
  color: $color-gray-600;
  letter-spacing: 0.25px;
}
</style>
